<template>
  <div>
    <div class="container">
      <div v-if="isPdfError" class="errorPic">
        <img src="@/assets/loading.png">
      </div>
      <div class="title" v-show="numPages">
        <h3 class="text"> </h3>
        <div class="tools">
          <span
            :theme="'default'"
            type="submit"
            :title="'基础按钮'"
            @click.stop="prePage"
            class="mr10"
          >
            上一页</span
          >
          <span
            :theme="'default'"
            type="submit"
            :title="'基础按钮'"
            @click.stop="nextPage"
            class="mr10"
          >
            下一页</span
          >
          <span class="page">{{ pageNum }}/{{ pageTotalNum }}</span>
          <span
            :theme="'default'"
            type="submit"
            :title="'基础按钮'"
            @click.stop="clock"
            class="mr10"
          >
            顺时针旋转</span
          >
          <!-- <span
            :theme="'default'"
            type="submit"
            :title="'基础按钮'"
            @click.stop="counterClock"
            class="mr10"
          >
            逆时针</span
          > -->
        </div>
      </div>
      <div class="imgbox">
        <!-- v-for="i in numPages" -->
        <!-- <pdf :src="remarkUrl" key="kkk" @page-loaded="pageLoaded"></pdf> -->
        <pdf
          ref="pdf"
          :src="remarkUrl"
          :page="pageNum"
          :rotate="pageRotate"
          @progress="loadedRatio = $event"
          @page-loaded="pageLoaded($event)"
          @num-pages="pageTotalNum = $event"
          @error="pdfError($event)"
          @click.prevent.stop="pdfError($event)"
        >
        </pdf>
      </div>
    </div>
  </div>
</template>


<script>
import pdf from "vue-pdf";
const picUrl = window.network["domianURL"] + "/";
export default {
  data() {
    return {
      isPdfError: false,
      pageNum: 1,
      remarkUrl: "",
      numPages: null, // pdf 总页数
      loadedRatio: 0,
      msg: null,
      pageTotalNum: 1,
      pageRotate: 0,
      curPageNum: 0,
    };
  },
  components: {
    pdf,
  },
  mounted() {
    this.remarkUrl = picUrl + this.$route.query.remarkUrl;
    this.getNumPages();
  },
  beforeRouteLeave(to, form, next) {
    setTimeout(this.msg, 0);
    next();
  },
  methods: {
    // 上一页函数，
    prePage() {
      var page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    // 下一页函数
    nextPage() {
      var page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
    // 页面顺时针翻转90度。
    clock() {
      this.pageRotate += 90;
    },
    // 页面逆时针翻转90度。
    counterClock() {
      this.pageRotate -= 90;
    },
    // 页面加载回调函数，其中e为当前页数
    pageLoaded(e) {
      this.curPageNum = e;
    },
    // 其他的一些回调函数。
    pdfError(error) {
      this.isPdfError = true
      setTimeout(this.msg, 0);

    },
    getNumPages() {
      this.msg = this.$message.loading({
        duration: 0,
        content: "正在加载，请稍后……",
      });
      let loadingTask = pdf.createLoadingTask(this.remarkUrl);
      loadingTask.promise.then((pdf) => {
        this.numPages = pdf.numPages;
        if (this.numPages) {
          setTimeout(() => {
            setTimeout(this.msg, 0);
          }, 8000);
          
        }  
      });
    },
  },
};
</script>

<style scoped>
.errorPic {
  width: 100%;
}
.errorPic img {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .container {
    width: 50%;
    margin: 0 auto;
  }
}
.tools {
  position: fixed;
  left: 0;
  top: 0;
}
.tools span {
  margin-left: 20px;
}
.title {
  height: 30px;
}
.imgbox{
  pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/views/reportDetail/reportDetail.vue